import { MessageHandlerBase } from "./MessageHandlerBase";
export default class LaunchIvaHandler extends MessageHandlerBase {
    constructor(almeState, setAlmeState, appConfig, apiUtils, ivaSetChatStatus) {
        super(almeState, setAlmeState, appConfig, apiUtils);
        this.ivaSetChatStatus = ivaSetChatStatus;
    }
    handle(message) {
        this.setAlmeState(Object.assign(Object.assign({}, this.almeState), { isOpen: true, launchPointName: message.launchPointName, launchParameter: message.launchParameter }));
        this.ivaSetChatStatus.openChat();
    }
}
